import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from './auth/auth.service';
import { ErrorService } from './utils/error.service';
import { environment } from '../../environments/environment';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private errorService: ErrorService,
    private authService: AuthService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authReq = req;

    // Add Auth Header Automatically
    const token = this.authService.getUserToken();
    const isOwnApi = req.url.startsWith(environment.PLATFORM_API_URL) || req.url.startsWith(environment.HOLLINGBERY_API_URL);

    if (token && isOwnApi) {
      const headers: { [name: string]: string } = { Authorization: token };
      // Lets KragworksHub attribute usage metrics to the web portal vs. the mobile app.
      // Platform API only — the Hollingbery API's CORS config doesn't allow custom headers.
      if (req.url.startsWith(environment.PLATFORM_API_URL)) {
        headers['X-Kw-Client'] = 'web';
      }
      authReq = req.clone({ setHeaders: headers });
    }

    // Global Error Handling
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {

        switch (error.status) {

          case 401:
            // Unauthorized
            this.errorService.showError('Session expired. Please login again.');
            this.authService.logout();
            this.router.navigate(['/login']);
            break;

          case 403:
            // Forbidden
            this.errorService.showError('You do not have permission to perform this action.');
            break;

          case 500:
            // Server error
            this.errorService.showError('Something went wrong. Please try again later.');
            break;

        }

        return throwError(error);
      })
    );
  }
}
